import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';

const DatePicker = element => {
  flatpickr(element.lastElementChild.firstElementChild, {
    dateFormat: 'M J Y @ H:iK',
    minDate: "today",
    enableTime: true,
    minTime: "10:30",
    maxTime: "16:00",
    time_24hr: true,
    disableMobile: true
  });
};

export default DatePicker;


// WEBPACK FOOTER //
// ./src/js/app/components/DatePicker.js